<template>
  <div>
    <menu-pae :inFocus="false">
      <menu-processo :numeroProcesso="numeroProcesso" :apensado="apensado"/>
    </menu-pae>

    <div class="d-flex justify-content-center">
      <div class="row container-md">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/elaboracao/consulta">Elaboração</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Volume</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-7 col-sm-12 text-md-right text-sm-center" style="padding: 0.75rem 1rem;">
          <div id="numeroProcesso" class="form-row">
            <div id="protocolo" class="col">
              <span>
                <h5>
                  <span class="badge badge-primary">Protocolo: <router-link class="text-white" :to="`/virtus/visualizadorProcesso?numeroProcesso=${numeroProcesso}`">{{ formatarProtocolo(numeroProcesso) }}</router-link></span>
                  <span v-show="volumeAtual" class="badge badge-primary ml-3">
                    Volume Atual: <span class="font-weight-bold">
                      {{ String(volumeAtual).padStart(3, '0') }}
                    </span>
                  </span>
                </h5>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-primary mb-1" @click.prevent="$refs.confirmacaoCriacao.openModal()">Novo Volume</button>
          <button v-if="quantidadeVolumes >= 2" type="button" class="btn btn-outline-danger ml-1 mb-1" @click.prevent="$refs.confirmacaoExclusao.openModal()">Excluir Último Volume</button>
        </div>
        <div class="col-12 text-sm-center">
          <data-table-consulta-comp class="p-2"
            :colNames="colNames"
            :eventBusDataName="eventBusDataName"
            :eventBusDataPaginationName="eventBusPaginationName"
            :dataTableColumn="dataTableColumn"
            :colWidth="colWidth">
            <template v-slot="slotProps">
              <td style="text-align: center; width: 100px !important;">
                <i
                  v-tooltip.auto-start="`Baixar Etiqueta - Volume ${slotProps.itemData.numero}`"
                  class="fa fa-download fa-1-5x text-info link mr-2"
                  aria-hidden="true"
                  v-on:click="downloadEtiqueta(slotProps.itemData.numero)"
                ></i>
              </td>
            </template>
          </data-table-consulta-comp>
        </div>
      </div>
    </div>
    <modal ref="confirmacaoCriacao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Realmente deseja criar um novo volume?</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.confirmacaoCriacao.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.confirmacaoCriacao.closeModal()">Cancelar</button>
          <button type="button" class="btn btn-outline-primary m-1" @click.prevent="novoVolume()">Confirmar</button>
        </div>
      </template>
    </modal>

    <modal ref="confirmacaoExclusao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Realmente deseja excluir o último volume?</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.confirmacaoExclusao.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="container">
          <div class="form-group row">
            <label for="" class="col-sm-12">Motivo:<span class="text-danger">*</span></label>
            <div class="col-sm-12">
              <div class="form-group input-group">
                <textarea
                  id="informacoes-complementares"
                  class="form-control"
                  rows="3"
                  v-model.trim="motivo"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.confirmacaoExclusao.closeModal()">Cancelar</button>
          <button type="button" :class="`btn btn-outline-primary m-1 ${buttonClass}`" @click.prevent="excluirVolume()">Confirmar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import menuProcesso from '@/components/MenuProcesso.vue'

import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'
import eventBus from '@/uteis/eventBus'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import DataValues from '@/components/data-table-consulta/DataValues'
import modal from '@/components/shared/Modal.vue'

import VistusService from '@/services/VirtusService'
import VirtusRepositoryService from '@/services/VirtusRepositoryService'

export default {
  name: 'volume',

  components: {
    menuPae,
    menuProcesso,
    dataTableConsultaComp,
    modal
  },

  created () {
    this.numeroProcesso = this.$route.query.numeroProcesso
    this.apensado = this.$route.query.apensado
    this.sessao = this.$store.getters.getDadosSessao.sessao
    this.service = new VistusService()
    this.serviceRepository = new VirtusRepositoryService()

    this.buscarVolumes()
  },

  computed: {
    buttonClass: function () {
      return this.motivo === '' ? 'disabled' : ''
    }
  },

  data () {
    return {
      eventBusDataName: 'consultaVolumes',
      eventBusPaginationName: 'consultaVolumesDataPagination',
      colNames: ['Data', 'Número Volume', 'Ações'],
      colWidth: [30, 40, 30],
      dataTableColumn: ['data', 'numero'],
      volumeAtual: null,
      quantidadeVolumes: 0,
      motivo: ''
    }
  },

  methods: {
    buscarVolumes () {
      this.service.buscarVolumesDoProcesso(this.numeroProcesso).then((data) => {
        var numeroPagina = 1
        var rowsNumber = 100

        var dataValues = new DataValues(data.volumes, numeroPagina, rowsNumber)

        this.volumeAtual = data.volumeAtual
        this.quantidadeVolumes = data.volumes.length
        eventBus.$emit(this.eventBusDataName, dataValues)
      }).catch((error) => {
        console.log(error)
      })
    },

    excluirVolume () {
      if (this.motivo === '') {
        return
      }

      this.service.excluirVolume(this.numeroProcesso).then(() => {
        this.buscarVolumes()
      }).catch((error) => {
        console.log(error)
      })

      const sessao = { ...this.$store.getters.getDadosSessao.sessao }
      const descricao = `Volume do Processo Nº ${this.formatarProtocolo(this.numeroProcesso)} foi desfeito, pelo seguinte motivo: ${this.motivo}`
      this.service.registrarHistorico(sessao, this.numeroProcesso, descricao).then(() => {
        this.buscarVolumes()
      }).catch((error) => {
        console.log(error)
      })

      this.$refs.confirmacaoExclusao.closeModal()
    },

    downloadEtiqueta (numeroVolume) {
      this.serviceRepository.dowloadEtiqueta(this.numeroProcesso, numeroVolume).then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' })

        var filename = `etiqueta${this.numeroProcesso}.pdf`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob)
        } else {
          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL, filename)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    novoVolume () {
      this.service.inserirNovoVolume(this.numeroProcesso, this.sessao).then(() => {
        this.buscarVolumes()
      }).catch((error) => {
        console.log(error)
      })

      this.$refs.confirmacaoCriacao.closeModal()
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    }
  }
}
</script>

<style scoped>
</style>
